import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const dateOfBirthBounds: ValidatorFn = (
  group: AbstractControl,
): ValidationErrors | null => {
  const dateOfBirth = group.get('dateOfBirth');

  if (!dateOfBirth) {
    return null; // no control, nothing to validate
  }

  const value = dateOfBirth.value;
  if (!value) {
    return null; // empty field is handled by Validators.required
  }

  const dob = new Date(value);
  const today = new Date();
  const oldestAllowed = new Date(1900, 0, 1); // Jan 1, 1900

  // Validate: must be between Jan 1, 1900 and today (no future dates)
  if (dob < oldestAllowed || dob > today) {
    const error = { dateOfBirthBounds: true };
    dateOfBirth.setErrors({ ...(dateOfBirth.errors || {}), ...error });
    return error;
  } else {
    // clear previous error if it was set
    if (dateOfBirth.errors && dateOfBirth.errors['dateOfBirthBounds']) {
      const { dateOfBirthBounds, ...remaining } = dateOfBirth.errors;
      dateOfBirth.setErrors(Object.keys(remaining).length ? remaining : null);
    }
    return null;
  }
};
